<!-- コードが間違えている、もしくは対象外ダイアログ -->
<template>
  <ItemDialog ref="DialogQRAuthBadRequest" image-type="alert">
    <template #content-area>
      <p style="text-align: center">
        利用対象外のコードかコードが間違えているため引き換えできませんでした。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="戻る"
        action-type="btn-primary"
        @clicked="clickClose"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "DialogQRAuthBadRequest",
  props: {
    isReturnSheet: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogQRAuthBadRequest = ref(null);
    const book = store.getters["ticketing/book"];
    const sheet = store.getters["ticketing/sheet"];

    const openDialog = () => {
      DialogQRAuthBadRequest.value.open();
    };

    const closeDialog = () => {
      DialogQRAuthBadRequest.value.close();
    };

    const goToSheet = () => {
      router.push({
        name: "Sheet",
        params: {
          book_group_id: route.params.book_group_id,
          book_id: book.id,
          master_sheet_id: sheet.master_sheet_id,
          sheet_id: String(sheet.id),
        },
        query: { language: store.getters["common/lang"] },
      });
    };

    const clickClose = () => {
      props.isReturnSheet ? goToSheet() : closeDialog();
    };

    return {
      DialogQRAuthBadRequest,
      openDialog,
      closeDialog,
      clickClose,
      props,
    };
  },
};
</script>
